<section class="plan-selector" aria-labelledby="choose-plan-title">
  <header class="selector-heading">
    <p class="step-caption">PASO 1 <span aria-hidden="true">/</span> CONFIGURA TU CUENTA</p>
    <h1 id="choose-plan-title">Tu Contalink, a tu medida.</h1>
    <p class="heading-note">Elige tu plan y cuántos contadores lo usarán.</p>
  </header>

  <p class="referral-note" *ngIf="referredId">{{ referredName || 'Tu contacto' }} te invita. Tu beneficio se aplica al total.</p>

  <div class="setup-layout">
    <section class="plan-options" aria-labelledby="plans-label">
      <div class="section-heading">
        <h2 id="plans-label">Elige tu plan</h2>
        <a class="details-link" href="https://www.contalink.com/precios" target="_blank" rel="noopener noreferrer">Comparar planes <span aria-hidden="true">↗</span><span class="visually-hidden"> (abre en otra pestaña)</span></a>
      </div>

      <fieldset class="plan-grid">
        <legend class="visually-hidden">Plan de Contalink</legend>
        <div class="plan-option" *ngFor="let card of cards">
          <input class="choice-input" type="radio" name="signup-plan" [id]="'signup-plan-' + card.type"
            [value]="card.type" [checked]="selectedType === card.type" (change)="selectPlan(card.type)">
          <label class="plan-card" [for]="'signup-plan-' + card.type" [class.is-selected]="selectedType === card.type">
            <span class="card-heading"><span class="plan-name">{{ card.name }}</span><span class="selection-dot" aria-hidden="true">{{ selectedType === card.type ? '✓' : '' }}</span></span>
            <span class="plan-description">{{ card.description }}</span>
            <span class="card-price" *ngIf="monthlyPrice(card.type) !== null; else unavailablePrice">{{ formatCardMoney(monthlyPrice(card.type)) }}<small>/ mes</small></span>
            <ng-template #unavailablePrice><span class="card-price unavailable-price">Por confirmar</span></ng-template>
            <span class="card-features"><strong>{{ card.rfcs }}</strong><span>{{ card.clients }}</span></span>
            <span class="selection-label">{{ selectedType === card.type ? 'Seleccionado' : 'Elegir ' + card.name }}<span aria-hidden="true">{{ selectedType === card.type ? '✓' : '→' }}</span></span>
          </label>
        </div>
      </fieldset>

      <p class="price-caption">Precios en MXN + IVA. Todos incluyen 1 contador.</p>

    </section>

    <aside class="configuration-panel" aria-labelledby="configure-title">
      <div class="section-heading"><h2 id="configure-title">Configura {{ selectedName }}</h2><button type="button" class="summary-plan" [attr.aria-describedby]="selectedType === 'FLEX' ? 'flex-rfc-note' : 'rfc-note'" (mouseenter)="highlightRfcHint()" (focus)="highlightRfcHint()" (click)="highlightRfcHint()">{{ rfcs }} RFCs</button></div>

      <div class="users-row">
        <h3 id="users-label">Usuarios contadores</h3>
        <div class="user-counter" role="group" aria-labelledby="users-label">
          <button type="button" aria-label="Quitar un usuario" [disabled]="users <= 1 || selectedType === 'START'" (click)="changeUsers(-1)">−</button>
          <output aria-live="polite" aria-atomic="true">{{ users }}</output>
          <button type="button" aria-label="Agregar un usuario" [disabled]="users >= 100"
            [attr.aria-disabled]="selectedType === 'START' ? 'true' : null"
            [attr.aria-describedby]="selectedType === 'START' ? 'start-users-note' : null"
            (mouseenter)="highlightStartUserHint()" (focus)="highlightStartUserHint()" (click)="changeUsers(1)">+</button>
        </div>
      </div>
      <p id="start-users-note" class="users-note start-users-note" [class.is-highlighted]="startUserHintHighlighted" [appMarkerHint]="startUserHintHighlighted" *ngIf="selectedType === 'START'">Incluye 1 contador. Para sumar más, <button type="button" (click)="selectPlan('PRO')">elige Pro</button>.</p>
      <p class="users-note" *ngIf="selectedType !== 'START'">1 incluido · {{ formatCardMoney(additionalUserPrice) }} + IVA / mes por adicional.<span id="flex-rfc-note" class="flex-rfc-note" [class.is-highlighted]="rfcHintHighlighted" [appMarkerHint]="rfcHintHighlighted" *ngIf="selectedType === 'FLEX'">Cada contador suma 100 RFCs.</span></p>

      <fieldset class="billing-options">
        <legend>Forma de pago</legend>
        <div class="billing-grid" [class.is-annual]="recurrence === 12">
          <div class="billing-option">
            <input class="choice-input" type="radio" name="signup-billing" id="signup-monthly" [checked]="recurrence === 1" [disabled]="!isRecurrenceAvailable(1)" (change)="selectRecurrence(1)">
            <label for="signup-monthly" [class.is-selected]="recurrence === 1">Mensual</label>
          </div>
          <div class="billing-option">
            <input class="choice-input" type="radio" name="signup-billing" id="signup-annual" [checked]="recurrence === 12" [disabled]="!isRecurrenceAvailable(12)" (change)="selectRecurrence(12)">
            <label for="signup-annual" [class.is-selected]="recurrence === 12">Anual <span class="saving-badge" *ngIf="annualSavingsPercent > 0">−{{ annualSavingsLabel }}%</span></label>
          </div>
        </div>
      </fieldset>

      <div class="order-summary" aria-live="polite" aria-atomic="true">
        <dl class="summary-breakdown">
          <div><dt>Plan {{ selectedName }}</dt><dd>{{ formatMoney(planAmount) }}</dd></div>
          <div class="additional-users-row" *ngIf="users > 1"><dt>{{ users - 1 }} {{ users === 2 ? 'usuario adicional' : 'usuarios adicionales' }}</dt><dd>{{ formatMoney(additionalUsersAmount) }}</dd></div>
          <div class="discount-row" *ngIf="discount > 0"><dt>{{ recurrence === 12 ? 'Ahorro anual' : 'Descuento' }}</dt><dd>−{{ formatMoney(discount) }}</dd></div>
          <div><dt>IVA (16%)</dt><dd>{{ formatMoney(iva) }}</dd></div>
        </dl>
        <div class="total-row"><div><strong>Total {{ recurrence === 12 ? 'anual' : 'mensual' }}</strong><small>MXN · IVA incluido</small></div><strong class="total-amount">{{ formatMoney(total) }}</strong></div>
      </div>
      <button class="continue-button" type="button" [disabled]="!canContinue" (click)="next()">Continuar <span aria-hidden="true">→</span></button>
      <p class="next-step-note" *ngIf="canContinue">Siguiente: tus datos de registro</p>
    </aside>

    <div class="plan-support">
      <div class="shared-benefits">
        <strong>En los tres planes</strong>
        <p><span>✓ Todos los módulos</span><span>✓ Timbres ilimitados</span><span>✓ Capacitación y soporte</span></p>
      </div>
      <p id="rfc-note" class="rfc-note" [class.is-highlighted]="rfcHintHighlighted && selectedType !== 'FLEX'"><span class="info-icon" aria-hidden="true">i</span><span class="rfc-note-copy" [appMarkerHint]="rfcHintHighlighted && selectedType !== 'FLEX'">¿Necesitas más RFCs? Los agregamos después de activar tu cuenta, con ayuda de tu ejecutivo.<small *ngIf="selectedType === 'START'">En Start, primero cambiarías a Pro o Flex.</small></span></p>
    </div>
  </div>
</section>
